import { FORCE_RELOAD_IFRAME } from "./iframeActions";

const initialState = {
  reloadSignal: 0,
};

export const iframeReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case FORCE_RELOAD_IFRAME:
      return {
        ...state,
        reloadSignal: action.payload,
      };
    default:
      return state;
  }
};
